export { default } from "./TransferirVendedor";
